import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/molecules/SEO';
import TwoColumn from '../components/molecules/TwoColumn';
import Column from '../components/molecules/Column';
import LongArrowLink from '../components/atoms/LongArrowLink';
import CircleText from '../components/atoms/CircleText';
import MarkdownConverter from '../components/atoms/MarkdownConverter';
import GatsbyImage from 'gatsby-image';
import styled from 'styled-components';

const ExtraImageHolder = styled.div`
  .gatsby-image-wrapper {
    margin: 0;
  }
`;

const Links = styled.p`
  display: flex;
  align-items: center;
  margin-top: 3rem;
  >:first-child {
    margin-right: 3rem;
  }
`;

function Page( { data } ) {

    const { title, date, text, heroImage, secondaryImage, badgeText, secondaryText } = data.contentfulBlogPost;

    return (
      <>
          <SEO title={title}/>
          <TwoColumn>
              <Column width="1/7">
                  <h1>{title}</h1>
                  <p><em>{date}</em></p>
                <MarkdownConverter content={text.text}/>
                  <Links>
                      <LongArrowLink to="/" text="Back to home"/>
                  </Links>
              </Column>
              <Column width="8/13">
                  <GatsbyImage fluid={heroImage.fluid} />
              </Column>
          </TwoColumn>
          <TwoColumn>
              <Column width="1/7">
                  <ExtraImageHolder>
                      <GatsbyImage fluid={secondaryImage.fluid} />
                  </ExtraImageHolder>
                  {badgeText && <CircleText text={badgeText} length={180} top="calc(100% - 75px)" left="60%"/>}
              </Column>
              <Column width="8/13">
                  <MarkdownConverter content={secondaryText.secondaryText}/>
              </Column>
          </TwoColumn>
      </>
    )
}

export default Page;

export const postQuery = graphql`
    query($id: String!) {
        contentfulBlogPost(id: { eq: $id }) {
            title
            text {
                text
            }
            secondaryText {
                secondaryText
            }
            secondaryImage {
                fluid {
                    ...GatsbyContentfulFluid_withWebp_noBase64
                }
            }
            heroImage {
                fluid {
                    ...GatsbyContentfulFluid_withWebp_noBase64
                }
            }
            date(formatString: "Do MMMM YYYY")
            badgeText
        }
    }
`;
